export const handleContextMenu = (e) => {
  e.preventDefault();
};
